export {
  ShoppableEditorial,
  type ShoppableEditorialProps,
} from './ShoppableEditorial';
export { shoppableEditorialSchema } from './schema';
